export default __webpack_public_path__ + "static/form-grouping-dont-a5cd09046e27c3c03a4f469a4a1651a26831a6d560e54a3afba780e32313607b.png";